import React, { useState } from "react";
import { Link } from "react-router-dom";
import { loginFournisseur } from "../api/api";
import PasswordInput from "../components/PasswordInput";
import { consumeSessionExpiredMessage, saveFournisseurSession } from "../utils/auth";
import "./Auth.css";

const LOGO_SRC = "/logoamicale.png";

export default function FournisseurLogin() {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  React.useEffect(() => {
    const message = consumeSessionExpiredMessage();
    if (message) setErr(message);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr("");

    try {
      setLoading(true);
      const res = await loginFournisseur(login.trim(), password);
      saveFournisseurSession(res.data);
      window.location.href = res.data.must_change_password ? "/fournisseur/change-password" : "/fournisseur/dashboard";
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Login fournisseur incorrect.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="auth-page">
      <section className="auth-showcase">
        <div className="auth-logo-orbit">
          <img src={LOGO_SRC} alt="Logo Amicale Autoroutes" />
        </div>
        <span className="auth-eyebrow">Portail fournisseur</span>
        <h1>Un acces simple pour suivre les demandes amicale.</h1>
        <p>
          Connectez-vous avec votre compte fournisseur pour gerer vos demandes,
          consulter votre espace et mettre a jour votre mot de passe.
        </p>
        <div className="auth-feature-row">
          <span>Demandes</span>
          <span>Securite</span>
          <span>Suivi</span>
        </div>
      </section>

      <section className="auth-panel">
        <div className="auth-card">
          <div className="auth-card-header">
            <img src={LOGO_SRC} alt="" />
            <div>
              <span className="auth-eyebrow">Connexion fournisseur</span>
              <h2>Bienvenue</h2>
            </div>
          </div>

          {err ? <div className="auth-alert">{err}</div> : null}

          <form onSubmit={handleSubmit} className="auth-form">
            <label>
              <span>Login</span>
              <input
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                placeholder="Identifiant fournisseur"
                autoComplete="username"
              />
            </label>

            <label>
              <span>Mot de passe</span>
              <PasswordInput
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Votre mot de passe"
                autoComplete="current-password"
              />
            </label>

            <button type="submit" disabled={loading}>
              {loading ? "Connexion..." : "Se connecter"}
            </button>
          </form>

          <div className="auth-switch">
            Vous etes adherent ?
            <Link to="/"> Connexion adherent</Link>
          </div>
        </div>
      </section>
    </main>
  );
}
